import React from 'react'
import { DropdownDarkSVG, DropdownSVG } from 'src/components/Icons/Basic'
import palette from 'src/designSystem/variables/palette'
import styled, { css } from 'styled-components/macro'

export const AskQuestionContainer = styled.div<{ $expand: boolean }>`
  width: 100%;
  border-radius: 6px;
  position: relative;
  max-height: 350px;
  margin-top: 20px;
`

export const AskQuestionInputContainer = styled.div<{ $expand: boolean }>`
  position: relative;
  display: flex;
  flex-direction: row;

  background-color: none;
  border: 1px solid ${palette.neutral.black};
  padding: 10px;
  padding-left: 20px;
  padding-right: 15px;
  border-radius: 6px;
  top: 0;
  // if we are showing the dropdown, we want to remove the border radius on the bottom and the border on the bottom
  ${({ $expand }) =>
    $expand &&
    css`
      z-index: 2;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      border-bottom: none;
    `}
`

export const StyledAskQuestionInput = styled.input`
  outline: none;
  background: none;
  border: none;
  width: 100%;
`

export const StyledAskQuestionButton = styled.button<{
  isDisabled: boolean
  isLarge?: boolean
}>`
  border: none;
  color: ${palette.neutral.white};
  padding: 10px;
  border-radius: 6px;
  width: ${({ isLarge }) => (isLarge ? '250px' : '200px')};

  ${({ isDisabled }) =>
    isDisabled
      ? css`
          background: ${palette.purple['200']};
          cursor: not-allowed;
        `
      : css`
          background: ${palette.purple['500']};
          cursor: pointer;
        `}
`

export const StyledSelectAnswerTypeButton = styled.button.attrs(
  ({ children }) => (
    <>
      {children}
      <DropdownSVG />
    </>
  ),
)<{
  isDisabled: boolean
  isLarge?: boolean
}>`
  border: none;
  color: ${palette.neutral.black};
  padding: 10px;
  border-radius: 6px;
  position: relative;
  background: none;
  width: 250px;

  :hover {
    background: ${palette.neutral['30']};
  }
`

export const ChatHistoryContainer = styled.div`
  flex-direction: column;
  display: flex;
  max-height: 250px;
  overflow: auto;
`

export const QuestionHistoryContainer = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const QuestionnaireAnswerTypeDropdown = styled.button.attrs((props) => {
  return {
    textStyle: 'body.default',
    children: (
      <>
        {props.children}
        <DropdownDarkSVG />
      </>
    ),
  }
})`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  padding: 10px;
  border: none;
  border-radius: 6px;
  background: none;
  width: 265px;

  :hover {
    background-color: ${palette.green['30']};
  }

  &[aria-expanded='true'] {
    background-color: ${palette.green['50']};

    svg {
      transform: scaleY(-1);
    }
  }

  svg {
    transform: scaleY(1);
    transition: transform 0.35s;
    fill: ${palette.neutral['100']};
  }

  :after {
    display: none;
  }

  p {
    font-size: 12px;
    font-weight: 400;
    color: ${palette.neutral['700']};
  }
`

export const StyledChooseAnswerTypeDropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 240px;
  margin: 10px;
`

export const StyledSelectQcTypeButton = styled.div<{ isDisabled?: boolean }>`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-start;
  padding: 10px 5px;
  gap: 10px;
  border-radius: 5px;

  :hover {
    background-color: ${palette.neutral['50']};
  }

  ${({ isDisabled }) =>
    isDisabled ? 'cursor: not-allowed' : 'cursor: pointer'}
`

export const StyledCaption = styled.p<{ isDark?: boolean }>`
  font-size: 12px;
  color: ${({ isDark }) =>
    isDark ? palette.neutral['500'] : palette.neutral['300']};
`

export const AskQuestionSuggestionsContainer = styled.div<{ $isTI?: boolean }>`
  display: flex;
  flex-direction: column;

  position: absolute;
  top: 100%;
  left: -1px;
  z-index: 1;
  width: calc(100% + 2px);
  background-color: ${palette.neutral.white};
  border: 1px solid
    ${({ $isTI }) => ($isTI ? palette.neutral[100] : palette.neutral.black)};
  border-top: none;
  // we only want border radius on the bottom if we are not showing the dropdown
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 10px;

  ${({ $isTI }) =>
    $isTI &&
    css`
      border-radius: 0 0 6px 6px;
    `}
`

export const AskQuestionSuggestion = styled.div<{
  $isHighlighted?: boolean
  $isTI?: boolean
}>`
  padding: ${({ $isTI }) => ($isTI ? '10px 3px' : '10px 20px')};
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  :hover {
    background-color: ${palette.neutral['50']};
  }

  ${({ $isHighlighted }) =>
    $isHighlighted &&
    css`
      background-color: ${palette.neutral['50']};
    `}

  p,
  svg {
    color: ${palette.neutral['500']};
  }

  svg {
    height: 14px;
    width: 14px;
  }
`
